import { Annotation } from "models/chart";
import { EntityKind } from "models/entityKind";

import { BaseChart } from "./baseChart";
import { MinMaxT } from "./types";

export class RateDate extends BaseChart {
  getDefaultAxisMinMax(entityKind?: EntityKind): MinMaxT {
    return {
      xMin: entityKind === EntityKind.Well ? "2000" : null,
      xMax: entityKind === EntityKind.Well ? "2050" : null,
      yMin: null,
      yMax: null
    };
  }

  getDefaultAxis(
    sessionMinMax?: MinMaxT,
    lock?: number,
    isSeriesYExceedingMaxY?: boolean,
    entityKind?: EntityKind
  ): MinMaxT {
    const defaultMinMax = this.getDefaultAxisMinMax(entityKind);
    if (!sessionMinMax) {
      if (lock && isSeriesYExceedingMaxY) {
        return {
          ...defaultMinMax,
          yMax: isSeriesYExceedingMaxY ? lock : null
        };
      }

      return defaultMinMax;
    }
    const yMax = !isNaN(parseFloat(sessionMinMax?.yMax?.toString()))
      ? parseFloat(sessionMinMax?.yMax?.toString())
      : defaultMinMax.yMax;
    const yMin = !isNaN(parseFloat(sessionMinMax?.yMin?.toString()))
      ? parseFloat(sessionMinMax?.yMin?.toString())
      : defaultMinMax.yMin;
    const xMax = sessionMinMax?.xMax ?? defaultMinMax.xMax;
    const xMin = sessionMinMax?.xMin ?? defaultMinMax.xMin;
    return {
      xMin,
      xMax,
      yMin,
      yMax
    };
  }

  getMarkLineData(annotations: Annotation[], yMin: number) {
    const marklineData = annotations.map((item, index) => {
      return [
        {
          xAxis: item.xValue,
          yAxis: yMin,
          label: {
            show: true,
            formatter: () => item.comment
          }
        },
        {
          xAxis: item.xValue,
          y: `${100 + 25 * index}`
        }
      ];
    });
    return {
      lineStyle: {
        type: "dashed"
      },
      symbol: [],
      data: marklineData
    };
  }
}
